import React, { useState } from 'react';
import './Kalkulator.css';

export default function PoreskaKamataCalculator() {
  const [principal, setPrincipal] = useState('');
  const [rate, setRate] = useState(5);
  const [days, setDays] = useState('');

  const parsedPrincipal = parseFloat(principal) || 0;
  const parsedRate = parseFloat(rate) || 0;
  const parsedDays = parseInt(days, 10) || 0;

  // Kamata = glavnica * (stopa/100) * (dana/365)
  const interest = parsedPrincipal * (parsedRate / 100) * (parsedDays / 365);
  const total = parsedPrincipal + interest;

  const clearFields = () => {
    setPrincipal('');
    setRate(5);
    setDays('');
  };

  return (
    <div className="container">
      {/* Form section */}
      <div className="form-container">
        <div className="card">
          <div className="form-header">
            <h2>Kalkulator Poreske kamate</h2>
            <button className="clear-button" onClick={clearFields}>
              Očisti
            </button>
          </div>

          <div className="field-group">
            <label className="field-label">Glavnica (iznos):</label>
            <input
              type="number"
              className="field-input"
              value={principal}
              onChange={(e) => setPrincipal(e.target.value)}
              placeholder="0.00"
            />
          </div>

          <div className="field-group">
            <label className="field-label">Stopa kamate (%) :</label>
            <input
              type="number"
              className="field-input"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
              placeholder="npr. 5"
            />
          </div>

          <div className="field-group">
            <label className="field-label">Broj dana kašnjenja:</label>
            <input
              type="number"
              className="field-input"
              value={days}
              onChange={(e) => setDays(e.target.value)}
              placeholder="npr. 30"
            />
          </div>
        </div>
      </div>

      {/* Results section */}
      <div className="results-container">
        <div className="card results-section">
          <h3 className="subsection-title">Rezultati</h3>
          <div className="result-row">
            <span>Iznos kamate:</span>
            <span>{interest.toFixed(2)}</span>
          </div>
          <div className="result-row">
            <span>Ukupno (s kamatom):</span>
            <span>{total.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
